import { useState, useEffect } from "react";
import { Folder as FolderIcon } from '@mui/icons-material';
import ToolBar from "components/ToolBar";

export default function ImageManagerFolders({ dataImageCategories, selectedImageCategory, setSelectedImageCategory, imageList, setImageList }) {
  const [dataImageCategoryFilter, setDataImageCategoryFilter] = useState(null);
  
  useEffect(() => { 
    if(dataImageCategories !== undefined && dataImageCategories !== null && dataImageCategories !== "")
      setDataImageCategoryFilter(dataImageCategories.data) 
  }, [dataImageCategories])

  const handleSelectImageCategory = (imageCategory) => { 
    setSelectedImageCategory(imageCategory)
    setImageList(imageCategory.image_list)
  }

  const handleSearchImageCategory = (e) => {
    const dataFilter = dataImageCategories.data.filter(item => item.name.toLowerCase().includes(e.target.value.toLowerCase(), 0))
    setDataImageCategoryFilter(dataFilter)
  }

  return ( <>
    <div className="im-images-categories-container">
    { (dataImageCategoryFilter !== null && imageList === null) && <>
      <div className="im-images-toobox-container"> <ToolBar searchFunction={handleSearchImageCategory} /> </div>
      <div className="im-images-container">        
      { dataImageCategoryFilter.map((category, index) => 
        <div className={`im-image-category ${ selectedImageCategory && selectedImageCategory._id === category._id ? 'im-image-category-selected' : '' }`} key={ index } onClick={ () => handleSelectImageCategory(category) }>
          <FolderIcon sx={{ fontSize: 40 }} color="primary" /> <span>{ category.name }</span>
        </div>
      ) }
      </div>
    </> }
    </div>
  </> )
}